export default "__VITE_ASSET__d6ZpVsfY__"